import classNames from 'classnames';
import { Icon, IconProps } from '~/components/Icon/Icon';

export type ArrowRightProps = IconProps & {
  className?: string;
};
export const ArrowRight = ({ className, ...props }: ArrowRightProps) => (
  <Icon
    className={classNames('arrow-right', className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 11.7029L11.2971 18.4057L9.56151 16.6701L13.3015 12.9301H4.95623V10.4756H13.3015L9.56151 6.73563L11.2971 5L18 11.7029Z"
      fill="currentColor"
    />
  </Icon>
);
